import React from 'react';
import Icon from '../atoms/Icon';

function StateIllinoisIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 20 32">
      <g 
        fill='currentColor' 
        fillRule='nonzero'
      >
        <path d="M18.4615 18.4615L19.6923 17.2308L18.4615 3.69231L18 2.30769L17.2308 1.23077V0H3.69231V1.23077L4.92308 2.46154V3.69231L3.69231 6.15385H3.07692L2.46154 6.76923V8L3.07692 8.61538H3.69231V9.84615H3.07692L2.46154 10.4615V11.0769H1.84615L1.23077 11.6923V12.3077L0 13.5385V14.7692L0.640001 16.2252L2.63877 18.2794L4.10338 19.0474L3.69231 19.6923L4.30769 20.9231H6.15385V22.1538L4.92308 23.3846V24.6154L7.38462 27.0769H8.61538L9.84615 29.5385V30.7692L11.0769 32H12.3077V30.7692H13.5385L14.7692 32H16L14.7692 29.5385H16V28.3077L17.2308 27.0769V24.6154L19.6923 22.0948V20.9231L18.4615 19.6923V18.4615ZM16.8111 21.5225L14.7692 23.6123V26.0566L13.7502 27.0769H11.3686L10.1378 24.6154H8.40492L7.89538 23.8942L8.61538 23.1729V18.4615H7.39323H7.38462V17.9902L4.12923 16.2818L2.71508 14.8283L2.55508 14.4652L3.48062 13.5385H4.92308V12.3077H6.15385V6.73477L7.38462 4.27323V2.46154H15.0843L15.7809 3.43754L16.0345 4.20062L17.1348 16.3065L16 17.4425V20.7126L16.8111 21.5225Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(StateIllinoisIcon);
